import { render, staticRenderFns } from "./StatisticCardElevator.vue?vue&type=template&id=3f2f650a&scoped=true&"
import script from "./StatisticCardElevator.vue?vue&type=script&lang=js&"
export * from "./StatisticCardElevator.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardElevator.vue?vue&type=style&index=0&id=3f2f650a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f650a",
  null
  
)

export default component.exports